export default __webpack_public_path__ + "static/media/currency.a362701d.svg";